var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtcIconMask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.9 236.9",
    style: {
      enableBackground: "new 0 0 236.9 236.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F7931A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.3,147.1c-15.8,63.4-80.1,102.1-143.5,86.2c-63.4-15.8-102-80.1-86.2-143.5C19.4,26.3,83.6-12.3,147.1,3.5 C210.5,19.4,249.1,83.6,233.3,147.1z M170.6,101.6c2.4-15.8-9.6-24.2-26-29.9l5.3-21.3l-13-3.2l-5.2,20.8c-3.4-0.9-6.9-1.7-10.4-2.5 l5.2-20.9l-13-3.2l-5.3,21.3c-2.8-0.6-5.6-1.3-8.3-2l0-0.1L82,56.1L78.6,70c0,0,9.6,2.2,9.4,2.3c5.3,1.3,6.2,4.8,6.1,7.6L88,104.2 c0.4,0.1,0.8,0.2,1.4,0.4c-0.4-0.1-0.9-0.2-1.4-0.3l-8.5,34.1c-0.6,1.6-2.3,4-6,3.1c0.1,0.2-9.4-2.4-9.4-2.4L57.6,154l16.9,4.2 c3.1,0.8,6.2,1.6,9.3,2.4l-5.4,21.6l13,3.2l5.3-21.4c3.5,1,7,1.9,10.4,2.7l-5.3,21.3l13,3.2l5.4-21.6c22.2,4.2,38.8,2.5,45.8-17.5 c5.7-16.1-0.3-25.4-11.9-31.5C162.5,118.7,168.9,113.1,170.6,101.6z M141,143.2c-4,16.1-31.2,7.4-40,5.2l7.1-28.6 C116.9,122,145.2,126.4,141,143.2z M145,101.3c-3.7,14.7-26.3,7.2-33.6,5.4l6.5-25.9C125.2,82.6,148.8,86,145,101.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcIconMask);
export default __webpack_public_path__ + "static/media/btc_icon_mask.b485af75d49e23adbf343c6a715a48ce.svg";
export { ForwardRef as ReactComponent };